import { createStyles, IconButton, ListItem, ListItemIcon, ListItemText, makeStyles, Theme } from '@material-ui/core';
import React from 'react';
import { Accordion, AccordionDetails } from '../../../../../../components/accordion/accordion.styled';
import LaunchIcon from '@material-ui/icons/Launch';
import { MessagingNodeData } from '../flow';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerContainer: {
      paddingTop: 0,
      paddingBottom: 0
    },
    header: {
      padding: 0
    },
    internalNode: {
      backgroundColor: theme.palette.banner.info,
    },
    externalNode: {
      backgroundColor: theme.palette.banner.error,
    },
    rootNode: {
      color: '#fbfbfb',
      backgroundColor: '#3b3b3b',
      '&:hover': {
        borderColor: '#fbfbfbb3',
      },
      '&.selected': {
        borderColor: '#ffffffb3'
      },
      '& p': {
        color: '#fbfbfb90'
      },
      '& svg': {
        fill: '#fbfbfb'
      }
    }
  })
);

export function SelectedPanel(props: { icon: React.ReactNode, data: MessagingNodeData, externalLink?: string }) {

  const { icon, data, externalLink } = props;
  const { spec } = data;

  const classes = useStyles();

  const isInternalNode = data.scope === 'internal';
  const isRootNode = (isInternalNode && data.type === 'exchange');

  const className = `${isInternalNode ? classes.internalNode : classes.externalNode} ${isRootNode ? classes.rootNode : ''}`;

  return (
    <Accordion expanded className={className}>
      <AccordionDetails className={classes.headerContainer}>
        <ListItem className={classes.header}>
          <ListItemIcon>{icon}</ListItemIcon>
          <ListItemText primary={spec.name} secondary={spec.type} />
          {externalLink && (
            <IconButton edge="start" size="small" title="Go to broker" component="a" href={externalLink} target="_blank">
              <LaunchIcon />
            </IconButton>
          )}
        </ListItem>
      </AccordionDetails>
    </Accordion >
  );
};
